import type { InquiryFormValues } from "@/api/types/inquiry";
import type { InquiryCreateInput } from "@/api/hooks/useInquiries";

/** Normalize form strings to the API's nullable/typed fields. Shared by the
 * create dialog (POST) and the detail dialog (PATCH) — same field set. */
export function toApiInput(values: InquiryFormValues): InquiryCreateInput {
  const blankToNull = (v: string | undefined) =>
    v && v.trim() !== "" ? v.trim() : null;
  const guestCount = values.guest_count?.trim();

  return {
    contact_name: values.contact_name.trim(),
    event_date: blankToNull(values.event_date),
    event_type: values.event_type ? values.event_type : null,
    guest_count: guestCount ? Number.parseInt(guestCount, 10) : null,
    venue_name: blankToNull(values.venue_name),
    na_guests_expected: values.na_guests_expected ?? false,
    budget_band: blankToNull(values.budget_band),
    source: values.source ? values.source : null,
    message: blankToNull(values.message),
    email_consent: values.email_consent ?? false,
    sms_consent: values.sms_consent ?? false,
  };
}
